import { render, staticRenderFns } from "./ContactosPantalla.vue?vue&type=template&id=3d6806e8&"
import script from "./ContactosPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContactosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports